import { render, staticRenderFns } from "./BasicEncuesta.vue?vue&type=template&id=3fd5d8e8&"
import script from "./BasicEncuesta.vue?vue&type=script&lang=js&"
export * from "./BasicEncuesta.vue?vue&type=script&lang=js&"
import style0 from "./BasicEncuesta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QRadio} from 'quasar'
component.options.components = Object.assign({QRadio}, component.options.components || {})
